<template>
  <div class="toolbar">
    <div class="md-layout">
      <div class="md-layout-item md-large-size-100">
        <md-card>
          <md-card-content>
            <h5>Legenda</h5>
            <p>
              In de keuzelijst, voor de naam van de chauffeur, staan enkele
              getallen. Hieronder staat een voorbeeld met uitleg wat deze
              getallen betekenen.
            </p>
            <p>
              Voorbeeld:
              <img
                class="dropdownImage"
                src="data:image/png;base64,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"
              />
            </p>
            <b>[2-1-0]</b> - Het eerste gedeelte bevat informatie over deze
            dienst:
            <ul>
              <li>[<b>2</b>-1-0] - 2 chauffeurs primair beschikbaar.</li>
              <li>
                [2-<b>1</b>-0] - 1 chauffeur secundair beschikbaar (alleen
                zichtbaar indien deze optie is ingeschakeld).
              </li>
              <li>
                [2-1-<b>0</b>] - 0 chauffeurs tertiair beschikbaar (alleen
                zichtbaar indien deze optie is ingeschakeld).
              </li>
            </ul>
            <b>(3/4)</b> - Het tweede gedeelte bevat informatie over deze
            chauffeur:
            <ul>
              <li>(<b>3</b>/4) - Chauffeur staat 3 keer ingeroosterd.</li>
              <li>
                (3/<b>4</b>) - Chauffeur is beschikbaar voor maximaal 4
                diensten.
              </li>
            </ul>

            <p>
              Chauffeurs worden voor elke keuzelijst onderverdeeld in
              verschillende beschikbaarheden. Deze zijn:
            </p>

            <ul>
              <li>
                <b>Beschikbaar</b> - Chauffeur is beschikbaar voor deze dienst
                en kan ingeroosterd worden.
              </li>
              <li>
                <b>Beschikbaar 2e</b> - De chauffeur is beschikbaar als 2e keuze
                voor deze dienst en kan ingeroosterd worden.
              </li>
              <li>
                <b>Beschikbaar 3e</b> - De chauffeur is beschikbaar als 3e keuze
                voor deze dienst en kan ingeroosterd worden.
              </li>
              <li>
                <b>Maximaal aantal diensten bereikt</b> - De chauffeur is niet
                bechikbaar omdat het aantal diensten voor deze chauffeur
                overschreden is/wordt.
              </li>
              <li>
                <b>Diensten overlap</b> - De chauffeur is al ingedeeld op een
                andere dienst welke met de start-stop tijd overlap heeft met
                deze dienst.
              </li>
              <li>
                <b>Eventueel beschikbaar</b> - De chauffeur is misschien
                beschikbaar. Er zal contact gezocht moeten worden met de
                chauffeur om te bepalen of deze ingeroosterd kan worden.
              </li>
              <li>
                <b>Niet Beschikbaar</b> - Chauffeur is niet beschikbaar voor
                deze dienst en kan niet ingeroosterd worden.
              </li>
            </ul>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
h5 {
  font-weight: bolder;
}
.toolbar .md-layout .md-card {
  margin-bottom: 5px;
  margin-top: 5px;
}

.md-card img.dropdownImage {
  width: 216px;
  height: 25px;
}
</style>
